class NewsletterFormHandler
{
    constructor(dataLayer, salesforce_form_log_url, success_page_url, salesforce_post_url_pattern, newsletter_form_id) {
        this.dataLayer = dataLayer;
        this.salesforce_form_log_url = salesforce_form_log_url;
        this.success_page_url = success_page_url;
        this.salesforce_post_url_pattern = salesforce_post_url_pattern;
        this.newsletter_form_id = newsletter_form_id;

        this.form = document.querySelector('form[data-form-id=newsletter-form]');

        this.initListeners();
        this.initRequestObserver();
    }

    handleForm() {
        this.dataLayer.push({
            'event': 'form_inschrijven_nieuwsbrief'
        })

        const form_data = new FormData(this.form);
        form_data.append('form_name', 'newsletter_form');
        axios.post(this.salesforce_form_log_url, form_data).then(response => {
            const success = response.data.success;
            if (success) {
                console.log('form data handled');
            }
        })
    }

    initListeners() {
        this.form.addEventListener('submit', (event) => {
            this.handleForm();
        }, true);
    }

    initRequestObserver() {
        const observer = new PerformanceObserver((list) => {
            for (const entry of list.getEntries()) {
                if (
                    (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
                    && entry.name.startsWith(this.salesforce_post_url_pattern)
                    && entry.name.includes(this.newsletter_form_id)
                    && String(entry.responseStatus).startsWith('20')
                ) {
                    location.href = this.success_page_url;
                }
            }
        });

        observer.observe({type: 'resource', buffered: true});
    }
}

window.dataLayer = window.dataLayer || [];
new NewsletterFormHandler(window.dataLayer, salesforce_form_log_url, newsletter_success_page_url, salesforce_post_url_pattern, newsletter_form_id);
